import Tabs from '../../globalcomponents/Tabs';
import Tab from '../../globalcomponents/Tabs/Tab';
import Icon from '../../globalcomponents/Icon';
import { useTheme } from 'styled-components';
import Blink from '../Animations/Blink';
import BusinessIcon from '@mui/icons-material/Business';
import StorageIcon from '@mui/icons-material/Storage';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

export const AIR_CLIENT_ID = '6423d08b6ba5d39df3db3779';
export const GRIFFIS_CLIENT_ID = '62a69a4b8c1a211965ab7497';

const LeadInfoOptions = props => {
  const {
    selectedOption,
    setSelectedOptions,
    isKelseyQueryListFilled,
    isPromotionsEnabled
  } = props;

  const cardSelected = selectedOption === 'card';
  const unitSelected = selectedOption === 'unit';
  const coreKnowledgeSelected = selectedOption === 'coreKnowledge';
  const communitySettingsSelected = selectedOption === 'communitySettings';
  const promotionsSelected = selectedOption === 'promotions';
  const kelseyFeedbackSelected = selectedOption === 'kelseyFeedback';
  const theme = useTheme();

  return (
    <div
      style={{ margin: '0px' }}
      className=" d-flex-jst-space-around align-middle"
    >
      <Tabs
        background={theme?.background?.secondary}
        padding={'0 8px'}
        borderRadius={'4px'}
      >
        <Tab
          color="#5267FF"
          onClick={() => {
            setSelectedOptions('All');
          }}
          active={selectedOption === 'All'}
          inactiveOpacity="1"
        >
          <Icon
            src={`all-${theme.state}.svg`}
            tooltipText="All"
            imgStyle={{ opacity: selectedOption !== 'All' && '0.5' }}
          />
        </Tab>
        <Tab
          color="#5267FF"
          onClick={() => {
            setSelectedOptions('card');
          }}
          active={cardSelected}
          inactiveOpacity="1"
        >
          <Icon
            src={`lead-details-${theme.state}.svg`}
            tooltipText="Lead Details"
            imgStyle={{ opacity: !cardSelected && '0.5' }}
          />
        </Tab>
        <Tab
          color="#5267FF"
          onClick={() => {
            setSelectedOptions('unit');
          }}
          active={unitSelected}
          inactiveOpacity="1"
        >
          <Icon
            src={`unit-preference-${theme.state}.svg`}
            tooltipText="Unit Details"
            imgStyle={{ opacity: !unitSelected && '0.5' }}
          />
        </Tab>
        <Tab
          color="#5267FF"
          onClick={() => {
            setSelectedOptions('coreKnowledge');
          }}
          active={coreKnowledgeSelected}
          inactiveOpacity="1"
        >
          <StorageIcon
            sx={{
              fontSize: '20px',
              opacity: !coreKnowledgeSelected ? 0.5 : 1,
              cursor: 'pointer'
            }}
            titleAccess="Core Knowledge"
          />
        </Tab>
        <Tab
          color="#5267FF"
          onClick={() => {
            setSelectedOptions('communitySettings');
          }}
          active={communitySettingsSelected}
          inactiveOpacity="1"
        >
          <BusinessIcon
            sx={{
              fontSize: '20px',
              opacity: !communitySettingsSelected ? 0.5 : 1,
              cursor: 'pointer'
            }}
            titleAccess="Community Settings"
          />
        </Tab>
        {isPromotionsEnabled && (
          <Tab
            color="#5267FF"
            onClick={() => {
              setSelectedOptions('promotions');
            }}
            active={promotionsSelected}
            inactiveOpacity="1"
          >
            <LocalOfferIcon
              sx={{
                fontSize: '20px',
                opacity: !promotionsSelected ? 0.5 : 1,
                cursor: 'pointer'
              }}
              titleAccess="Promotions"
            />
          </Tab>
        )}
        <Tab
          color="#5267FF"
          onClick={() => {
            setSelectedOptions('kelseyFeedback');
          }}
          active={kelseyFeedbackSelected}
          inactiveOpacity="1"
        >
          <Icon
            src={`queries-${theme.state}.svg`}
            tooltipText="Kelsey Feedback"
            imgStyle={{ opacity: !kelseyFeedbackSelected && '0.5' }}
          />
          {!kelseyFeedbackSelected && isKelseyQueryListFilled && <Blink />}
        </Tab>
      </Tabs>
    </div>
  );
};
export default LeadInfoOptions;
